/*
  Packs que entran al carrito como productos sueltos.

  El precio de pack lo ponen los descuentos automaticos de la tienda, que
  Shopify resuelve solo: al cruzar un tramo aplica el mayor y descarta el otro.

  Si algun dia hiciera falta usar cupones en vez de reglas automaticas, basta
  con llenar "Tramos por cantidad" en los ajustes: la pagina vuelve a aplicar
  el cupon que corresponda a la cantidad que haya en el carrito.
*/
(() => {
  const configuracion = document.getElementById('pack-tiers-config');
  if (!configuracion) return;

  let datos;
  try {
    datos = JSON.parse(configuracion.textContent);
  } catch (e) {
    return;
  }

  // De mayor a menor: gana el tramo mas grande que alcance la cantidad.
  const tramos = (datos.tiers || []).slice().sort((a, b) => b.units - a.units);
  const elegibles = new Set(datos.products || []);
  const nuestros = new Set(tramos.map((tramo) => tramo.code.toUpperCase()));

  const conCupones = tramos.length > 0 && elegibles.size > 0;

  let trabajando = false;

  function cantidadElegible(carrito) {
    return (carrito.items || []).reduce(
      (total, linea) => (elegibles.has(linea.product_id) ? total + linea.quantity : total),
      0
    );
  }

  function cuponQueCorresponde(carrito) {
    const cantidad = cantidadElegible(carrito);
    const tramo = tramos.find((t) => cantidad >= t.units);
    return tramo ? tramo.code : '';
  }

  // Devuelve el cupon a aplicar, o null si no hay nada que cambiar. Si el
  // cliente puso un cupon suyo lo dejamos tranquilo: solo cabe uno.
  function decidir(carrito) {
    const puestos = (carrito.discount_codes || []).map((d) => d.code);
    if (puestos.some((codigo) => !nuestros.has(codigo.toUpperCase()))) return null;

    const mio = puestos.find((codigo) => nuestros.has(codigo.toUpperCase())) || '';
    const quiero = cuponQueCorresponde(carrito);

    return mio.toUpperCase() === quiero.toUpperCase() ? null : quiero;
  }

  function leerCarrito() {
    return fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
  }

  function actualizar(cuerpo) {
    return fetch(`${window.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(cuerpo),
    }).then((r) => r.json());
  }

  function seccionesDelCajon() {
    const cajon = document.querySelector('cart-drawer');
    return cajon ? cajon.getSectionsToRender().map((seccion) => seccion.id) : [];
  }

  // Aplicar el cupon no toca las lineas, pero si los totales: hay que repintar
  // el cajon y la pagina del carrito, que Dawn no refresca por su cuenta.
  async function repintar() {
    const cajonItems = document.querySelector('cart-drawer-items');
    if (cajonItems) {
      await cajonItems.onCartUpdate();
      return;
    }

    const items = document.querySelector('cart-items');
    if (!items) return;

    await items.onCartUpdate();

    const pie = document.getElementById('main-cart-footer');
    if (!pie) return;

    const respuesta = await fetch(`${window.routes.cart_url}?section_id=main-cart-footer`);
    const html = new DOMParser().parseFromString(await respuesta.text(), 'text/html');
    const nuevo = html.querySelector('#main-cart-footer .js-contents');
    const actual = pie.querySelector('.js-contents');
    if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;
  }

  // Revisa el carrito y deja puesto el cupon del tramo que corresponda.
  async function sincronizar() {
    if (!conCupones || trabajando) return;
    trabajando = true;

    try {
      const carrito = await leerCarrito();
      const cupon = decidir(carrito);
      if (cupon === null) return;

      await actualizar({ discount: cupon });
      await repintar();
    } catch (e) {
      // Un carrito sin descuento es preferible a una pagina rota.
    } finally {
      trabajando = false;
    }
  }

  // Agrega los sabores sueltos y muestra el carrito. Con cupones de por medio
  // se aplica el del tramo antes de pintar, para que los totales no salten a
  // la vista del cliente.
  async function agregar(items) {
    const cajonInicial = document.querySelector('cart-drawer');
    const secciones = seccionesDelCajon();

    if (!conCupones) {
      const respuesta = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items, sections: secciones, sections_url: window.location.pathname }),
      });

      const resultado = await respuesta.json();
      if (resultado.status) throw new Error(resultado.description || resultado.message);

      if (cajonInicial) cajonInicial.renderContents(resultado);
      else window.location.href = window.routes.cart_url;
      return;
    }

    const respuesta = await fetch(`${window.routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items }),
    });

    const agregado = await respuesta.json();
    if (agregado.status) throw new Error(agregado.description || agregado.message);

    const carrito = await leerCarrito();
    const cupon = decidir(carrito);

    const cuerpo = { sections: secciones, sections_url: window.location.pathname };
    if (cupon !== null) cuerpo.discount = cupon;

    let resultado = await actualizar(cuerpo);

    // Si el cupon no existe o no aplica, el carrito igual tiene que abrirse.
    if (!resultado || !resultado.sections) {
      delete cuerpo.discount;
      resultado = await actualizar(cuerpo);
    }

    const cajon = document.querySelector('cart-drawer');

    if (cajon) {
      cajon.renderContents(resultado);
    } else {
      window.location.href = window.routes.cart_url;
    }
  }

  window.packTiers = { sincronizar, agregar };

  // Cualquier cambio del carrito hecho por el tema (formulario de producto,
  // cantidades, eliminar) puede cruzar un tramo.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (evento) => {
      if (evento && evento.source === 'pack-tiers') return;
      sincronizar();
    });
  }

  document.addEventListener('DOMContentLoaded', sincronizar);
  if (document.readyState !== 'loading') sincronizar();
})();
